
const digest = '8a9674b2a5bdac523bddf817f1402ab9b381ca5ed5fa2df7b12ba86bec353a16';
const classes = {"title":"_title_eq22o_1"};
const css = `._title_eq22o_1 {
  font-weight: 600;
  font-size: 14px;
  padding: 18px 24px;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #f9fdff;
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  